import React from 'react';

export const AddFile: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="2 2 28 28" {...props}>
    <g transform="translate(3.68 4)">
      <path
        d="M14.253 23.469a.531.531 0 01.53-.531h6.8a1.68 1.68 0 001.679-1.681V2.742a1.68 1.68 0 00-1.679-1.681H6.743a1.68 1.68 0 00-1.679 1.681v4.191a.531.531 0 01-.53.531.531.531 0 01-.53-.531V2.746A2.741 2.741 0 016.743.004h14.843a2.741 2.741 0 012.739 2.742v18.516a2.741 2.741 0 01-2.739 2.742h-6.8a.531.531 0 01-.533-.535z"
        fill="currentColor"
      />
      <rect
        width="9.85"
        height="1.07"
        rx=".53"
        transform="translate(10.919 5.6)"
        fill="currentColor"
      />
      <rect
        width="11.79"
        height="1.28"
        rx=".64"
        transform="translate(.32 17.062)"
        fill="currentColor"
      />
      <rect
        width="4.98"
        height="1.07"
        rx=".53"
        transform="translate(15.783 11.466)"
        fill="currentColor"
      />
      <rect
        width="4.98"
        height="1.07"
        rx=".53"
        transform="translate(15.783 17.167)"
        fill="currentColor"
      />
      <rect
        width="1.28"
        height="11.79"
        rx=".64"
        transform="translate(5.543 11.771)"
        fill="currentColor"
      />
    </g>
  </svg>
);
